import { BaseUrl } from "./baseUrls";

export async function uploadGeneralFinalizedData(formData: FormData) {
    const url = `${BaseUrl}/uploadGeneralFinalizedData`;
    return fetch(url, {
        method: 'POST',
        body: formData,
    });
}
